import HttpRequest from './httpRequest'

export default class SystemConfigProvider extends HttpRequest {
  fetchSystemConfigs (type) {
    return this.fetch(`/system-configs/${type}`)
  }
}
